import { privateRequest } from "../axios";
import type { ListApiResponse } from "@/types/common";
import type { Category, CategoryParams } from "@/types/category";

const ENDPOINTS = {
  QUESTION_CATEGORIES: "/question-categories",
};

const getAllCategories = async (params?: CategoryParams) => {
  const response = await privateRequest.get<ListApiResponse<Category>>(ENDPOINTS.QUESTION_CATEGORIES, { params });
  return response.data;
};

const CategoryService = {
  getAllCategories,
};

export default CategoryService;
